export default "__VITE_ASSET__C0lCIC2c__"